import type {
  MarketEventExpenseCategory,
  MarketEventPaymentMethod,
  MarketEventStatus,
} from "@/server/platform/db/schema/event-sales";

export const EVENT_STATUS_LABELS: Record<MarketEventStatus, string> = {
  draft: "ຮ່າງ",
  open: "ກຳລັງຂາຍ",
  closed: "ປິດງານ",
};

export const EVENT_PAYMENT_LABELS: Record<MarketEventPaymentMethod, string> = {
  cash: "ເງິນສົດ",
  transfer: "ໂອນ",
};

export const EVENT_EXPENSE_LABELS: Record<MarketEventExpenseCategory, string> =
  {
    booth: "ຄ່າບູດ",
    transport: "ຄ່າເດີນທາງ",
    food: "ຄ່າອາຫານ",
    supplies: "ເຄື່ອງໃຊ້",
    other: "ອື່ນໆ",
  };

export const EVENT_EXPENSE_OPTIONS = (
  Object.entries(EVENT_EXPENSE_LABELS) as Array<
    [MarketEventExpenseCategory, string]
  >
).map(([value, label]) => ({ value, label }));
